import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
function getCartFromSessionStorage() {
  if (typeof window !== "undefined") {
    return sessionStorage.getItem("cart")
      ? JSON.parse(sessionStorage.getItem("cart"))
      : [];
  } else {
    console.log("Rendering on server");
  }
}

export const CartContext = React.createContext();
export function CartProvider({ children }) {
  const [cart, setCart] = useState(getCartFromSessionStorage());
  const [cartAmount, setCartAmount] = useState(0);
  const [sum, setSum] = useState();

  const data = useStaticQuery(
    graphql`
      query Context {
        allMdx(filter: { frontmatter: { title: { eq: "Product" } } }) {
          edges {
            node {
              id
              frontmatter {
                title
                featuredImage_alt
                price
                featuredImage {
                  childImageSharp {
                    gatsbyImageData(height: 128, breakpoints: 100)
                    fluid(maxHeight: 128) {
                      base64
                      tracedSVG
                      srcWebp
                      srcSetWebp
                      originalImg
                      originalName
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
              body
              slug
            }
          }
        }
      }
    `
  );
  function getProductsFromSessionStorage() {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem("products")
        ? JSON.parse(sessionStorage.getItem("products"))
        : [...data.allMdx.edges];
    } else {
      console.log("Rendering on server");
    }
  }
  const [products, setProducts] = useState(getProductsFromSessionStorage());
  function onUpdate() {
    let sum = cart;
    let sumAmount = [];
    if (sum[0] !== undefined) {
      sum.map((el) => sumAmount.push(el.price * el.amount));
      sumAmount = sumAmount.reduce((ac, el) => ac + el);
      setSum(sumAmount);
    } else {
      setSum(0);
    }
    setProducts((oldArray) => {
      const newProducts = oldArray.map((el) => {
        const item = cart.find(
          (item) => item.name === el.node.frontmatter.featuredImage_alt
        );
        if (item !== undefined) {
          el.cart = "cart";
        } else {
          el.cart = "none";
        }
        return el;
      });
      return [...newProducts];
    });
    setCartAmount(cart.length);
    if (typeof window !== "undefined") {
      sessionStorage.setItem("sum", JSON.stringify(sumAmount));
      sessionStorage.setItem("cart", JSON.stringify(cart));
      sessionStorage.setItem("cartAmount", cart.length);
      sessionStorage.setItem("products", JSON.stringify(products));
    } else {
      console.log("Rendering on server");
    }

    return products;
  }
  useEffect(onUpdate, [cart]);
  const newItemCart = function (product, price, img) {
    const item = cart.find((item) => item.name === product);
    if (!item) {
      setCart(
        cart.concat({
          name: product,
          amount: 1,
          price: price,
          img: img,
        })
      );

      onUpdate();
    }
  };

  const addAmount = (product, price) => {
    const item = cart.find((item) => item.name === product);
    if (item) {
      item.amount++;
      setCart((oldarray) => {
        const cart = oldarray.map((el) => (el.name !== product ? el : item));
        return [...cart];
      });
      onUpdate();
    }
  };
  const subtractAmount = (product) => {
    const item = cart.find((item) => item.name === product);
    if (item) {
      if (item.amount > 1) {
        item.amount--;
        setCart((oldarray) => {
          const cart = oldarray.filter((el) =>
            el.name !== product ? el : item
          );
          return [...cart];
        });

        onUpdate();
      }
    }
  };
  const deleteItem = (product) => {
    const item = cart.find((item) => item.name === product);
    if (item) {
      setCart((oldarray) => {
        const cart = oldarray.filter((el) => el.name !== product);
        return [...cart];
      });
      onUpdate();
    }
  };
  const cleanCart = () => {
    setCart([]);
    onUpdate();
  };
  return (
    <CartContext.Provider
      value={{
        cart,
        addAmount,
        subtractAmount,
        newItemCart,
        deleteItem,
        sum,
        cartAmount,
        products,
        onUpdate,
        cleanCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
